const services = {
  hero: {
    title: "Our Services",
    subtitle: "Professional cleaning and handyman services tailored to your needs.",
    breadcrumb: "Services",
  },
  categories: {
    cleaning: {
      title: "Cleaning Services",
      count: "4 services available",
      desc: "From regular maintenance to deep cleaning — we handle it all.",
    },
    handyman: {
      title: "Handyman Services",
      count: "10 services available",
      desc: "Repairs, installations, and improvements for every part of your home.",
    },
  },
  cleaning: {
    sectionTitle: "Cleaning Services",
    items: [
      {
        slug: "residential-cleaning",
        title: "Residential Cleaning",
        shortDesc: "Regular professional cleaning to keep your home fresh and tidy every week.",
        image: "https://readdy.ai/api/search-image?query=professional%20residential%20house%20cleaning%20service%20bright%20modern%20living%20room%20sparkling%20clean%20surfaces%20white%20walls%20natural%20light&width=600&height=400&seq=rc1&orientation=landscape",
      },
      {
        slug: "deep-cleaning",
        title: "Deep Cleaning",
        shortDesc: "Thorough top-to-bottom cleaning for a truly spotless home.",
        image: "https://readdy.ai/api/search-image?query=deep%20cleaning%20service%20professional%20cleaner%20scrubbing%20kitchen%20bathroom%20tiles%20bright%20clean%20home%20detailed%20cleaning&width=600&height=400&seq=dc1&orientation=landscape",
      },
      {
        slug: "move-in-out-cleaning",
        title: "Move-in / Move-out Cleaning",
        shortDesc: "Get your home ready for new beginnings — perfectly clean on arrival or departure.",
        image: "https://readdy.ai/api/search-image?query=move%20in%20move%20out%20cleaning%20empty%20house%20professional%20cleaning%20service%20bright%20rooms%20clean%20floors%20walls&width=600&height=400&seq=mo1&orientation=landscape",
      },
      {
        slug: "airbnb-cleaning",
        title: "Airbnb Cleaning",
        shortDesc: "Fast, reliable turnovers to keep your guests happy and reviews 5-star.",
        image: "https://readdy.ai/api/search-image?query=airbnb%20vacation%20rental%20cleaning%20service%20fresh%20bed%20linens%20bright%20bedroom%20clean%20bathroom%20professional%20hospitality&width=600&height=400&seq=ab1&orientation=landscape",
      },
    ],
  },
  handyman: {
    sectionTitle: "Handyman Services",
    items: [
      {
        slug: "drywall-repair",
        title: "Drywall Repair",
        shortDesc: "Holes, cracks, and damage — we restore your walls to perfect condition.",
        image: "https://readdy.ai/api/search-image?query=drywall%20repair%20professional%20handyman%20patching%20wall%20holes%20smooth%20finish%20white%20wall%20home%20repair&width=600&height=400&seq=dw1&orientation=landscape",
      },
      {
        slug: "door-repairs",
        title: "Door Repairs",
        shortDesc: "Locks, hinges, alignment — we fix all door issues quickly and reliably.",
        image: "https://readdy.ai/api/search-image?query=door%20repair%20handyman%20fixing%20door%20lock%20hinge%20alignment%20residential%20home%20interior%20professional%20service&width=600&height=400&seq=dr1&orientation=landscape",
      },
      {
        slug: "cabinet-fixes",
        title: "Cabinet & Drawer Fixes",
        shortDesc: "Loose hinges, broken drawers, misaligned doors — we handle all cabinet repairs.",
        image: "https://readdy.ai/api/search-image?query=cabinet%20drawer%20repair%20handyman%20fixing%20kitchen%20cabinet%20hinges%20drawers%20home%20improvement%20professional&width=600&height=400&seq=cf1&orientation=landscape",
      },
      {
        slug: "interior-painting",
        title: "Interior Painting & Touch-ups",
        shortDesc: "Fresh coats and precise touch-ups to make your walls look brand new.",
        image: "https://readdy.ai/api/search-image?query=interior%20painting%20professional%20painter%20rolling%20white%20paint%20on%20wall%20bright%20clean%20room%20home%20improvement&width=600&height=400&seq=ip1&orientation=landscape",
      },
      {
        slug: "tv-mounting",
        title: "TV Mounting & Installations",
        shortDesc: "Safe, clean TV mounting with cable management for a polished look.",
        image: "https://readdy.ai/api/search-image?query=tv%20mounting%20installation%20professional%20handyman%20mounting%20flat%20screen%20television%20on%20wall%20modern%20living%20room&width=600&height=400&seq=tv1&orientation=landscape",
      },
      {
        slug: "furniture-assembly",
        title: "Furniture Assembly",
        shortDesc: "We assemble all types of furniture quickly and correctly.",
        image: "https://readdy.ai/api/search-image?query=furniture%20assembly%20professional%20handyman%20assembling%20ikea%20furniture%20bedroom%20living%20room%20home%20service&width=600&height=400&seq=fa1&orientation=landscape",
      },
      {
        slug: "pressure-washing",
        title: "Pressure Washing",
        shortDesc: "Powerful cleaning for driveways, patios, fences, and exterior surfaces.",
        image: "https://readdy.ai/api/search-image?query=pressure%20washing%20driveway%20patio%20professional%20cleaning%20service%20powerful%20water%20jet%20clean%20concrete%20outdoor&width=600&height=400&seq=pw1&orientation=landscape",
      },
      {
        slug: "gutter-cleaning",
        title: "Gutter Cleaning",
        shortDesc: "Clear clogged gutters to protect your home from water damage.",
        image: "https://readdy.ai/api/search-image?query=gutter%20cleaning%20professional%20service%20removing%20leaves%20debris%20from%20roof%20gutters%20residential%20home%20maintenance&width=600&height=400&seq=gc1&orientation=landscape",
      },
      {
        slug: "fence-repairs",
        title: "Fence Repairs",
        shortDesc: "Fix broken, leaning, or damaged fences to restore safety and curb appeal.",
        image: "https://readdy.ai/api/search-image?query=fence%20repair%20professional%20handyman%20fixing%20wooden%20fence%20residential%20backyard%20home%20improvement%20outdoor&width=600&height=400&seq=fr1&orientation=landscape",
      },
      {
        slug: "landscaping",
        title: "Small Landscaping",
        shortDesc: "Lawn care, trimming, and small landscaping to keep your yard beautiful.",
        image: "https://readdy.ai/api/search-image?query=small%20landscaping%20service%20professional%20lawn%20care%20trimming%20plants%20residential%20yard%20beautiful%20green%20garden%20Florida&width=600&height=400&seq=ls1&orientation=landscape",
      },
    ],
  },
};

export default services;
